<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="手机号" prop="mobile">
                <a-input v-model="queryParam.mobile" placeholder="请输入手机号" @pressEnter="handleQuery" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="昵称" prop="nickname">
                <a-input v-model="queryParam.nickname" placeholder="请输入昵称" @pressEnter="handleQuery" allow-clear />
              </a-form-item>
            </a-col>
            <!--            <a-col :md="8" :sm="24">-->
            <!--              <a-form-item label="邮箱" prop="email">-->
            <!--                <a-input v-model="queryParam.email" placeholder="请输入邮箱" allow-clear/>-->
            <!--              </a-form-item>-->
            <!--            </a-col>-->
            <!--            <template v-if="advanced">-->

            <!--              <a-col :md="8" :sm="24">-->
            <!--                <a-form-item label="性别" prop="sex">-->
            <!--                  <a-select placeholder="请选择性别" v-model="queryParam.sex" style="width: 100%" allow-clear>-->
            <!--                    <a-select-option v-for="(d, index) in dict.type.sys_user_sex" :key="index" :value="d.value">{{ d.label }}</a-select-option>-->
            <!--                  </a-select>-->
            <!--                </a-form-item>-->
            <!--              </a-col>-->
            <!--              <a-col :md="8" :sm="24">-->
            <!--                <a-form-item label="邀请码" prop="invitationCode">-->
            <!--                  <a-input v-model="queryParam.invitationCode" placeholder="请输入邀请码" allow-clear/>-->
            <!--                </a-form-item>-->
            <!--              </a-col>-->
            <!--              <a-col :md="8" :sm="24">-->
            <!--                <a-form-item label="是否推送" prop="isNotice">-->
            <!--                  <a-select placeholder="请选择是否推送" v-model="queryParam.isNotice" style="width: 100%" allow-clear>-->
            <!--                    <a-select-option v-for="(d, index) in dict.type.sys_notice_status" :key="index" :value="d.value">{{ d.label }}</a-select-option>-->
            <!--                  </a-select>-->
            <!--                </a-form-item>-->
            <!--              </a-col>-->
            <!--              <a-col :md="8" :sm="24">-->
            <!--                <a-form-item label="用户状态" prop="status">-->
            <!--                  <a-select placeholder="请选择用户状态" v-model="queryParam.status" style="width: 100%" allow-clear>-->
            <!--                    <a-select-option v-for="(d, index) in dict.type.sys_enable_disable" :key="index" :value="d.value">{{ d.label }}</a-select-option>-->
            <!--                  </a-select>-->
            <!--                </a-form-item>-->
            <!--              </a-col>-->
            <!--            </template>-->
            <a-col :md="(!advanced && 8) || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}"
              >
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
                <!--                <a @click="toggleAdvanced" style="margin-left: 8px">-->
                <!--                  {{ advanced ? '收起' : '展开' }}-->
                <!--                  <a-icon :type="advanced ? 'up' : 'down'"/>-->
                <!--                </a>-->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <!-- <div class="table-operations">
        <table-setting
          :style="{ float: 'right' }"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList"
        />
      </div> -->
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        :sexOptions="dict.type.sys_user_sex"
        :isNoticeOptions="dict.type.sys_notice_status"
        :statusOptions="dict.type.sys_enable_disable"
        @ok="getList"
      />
      <!-- <create-form
        ref="createForm"

        @ok="getList"
      /> -->
      <!-- 动态管理 -->
      <a-drawer width="70%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
        <manage-ment v-if="names == 'manageMent'" ref="manageMent" type="tk" />
        <vou-cher v-if="names == 'vouCher'" ref="vouCher" type="tk"></vou-cher>
        <!-- 积分 -->
        <score-balance v-if="names == 'scoreBalance'" ref="scoreBalance" type="tk"></score-balance>

        <coin-record v-if="names == 'coinBalance'" ref="coinBalance" type="tk"></coin-record>

        <recharge-num v-if="names == 'rechargeNum'" ref="rechargeNum" type="tk"></recharge-num>
        <withdrawal v-if="names == 'withdrawal'" ref="withdrawal" type="tk"></withdrawal>
        <!-- 商品订单数-》订单管理 -->
<!--        <a-tabs type="card" v-model:activeKey="activeKey" @change="changeOrder" v-if="names == 'order'">-->
<!--          <a-tab-pane key="order" tab="兑换商城订单"><order ref="order" type="tk"></order></a-tab-pane>-->
<!--          <a-tab-pane key="health" tab="闲橙健康订单"><health ref="health" type="tk"></health></a-tab-pane>-->
<!--          <a-tab-pane key="youxuan" tab="闲橙优选订单"><youxuan ref="youxuan" type="tk"></youxuan></a-tab-pane>-->
<!--        </a-tabs>-->
        <a-tabs type="card" v-model:activeKey="activeKeys" @change="changeTabs" v-if="names == 'motion'">
<!--          <a-tab-pane key="motion" tab="运动">-->
<!--            <Motion ref="motion" type="tk"></Motion>-->
<!--          </a-tab-pane>-->
<!--          <a-tab-pane key="diet" tab="饮食">-->
<!--            <Diet ref="diet" type="tk"></Diet>-->
<!--          </a-tab-pane>-->
<!--          <a-tab-pane key="drinkWater" tab="饮水记录">-->
<!--            <DrinkWater ref="drinkWater" type="tk"></DrinkWater>-->
<!--          </a-tab-pane>-->
<!--          <a-tab-pane key="dietaryAnalysis" tab="饮食分析">-->
<!--            <DietaryAnalysis ref="dietaryAnalysis" type="tk"></DietaryAnalysis>-->
<!--          </a-tab-pane>-->
        </a-tabs>
        <!-- 会员类型=》会员订单 -->
        <MemberOrder v-if="names == 'memberOrder'" ref="memberOrder" type="tk"></MemberOrder>
        <!-- 已购课= 课程管理=》订单管理 -->
        <PurchasedCourses v-if="names == 'purchasedCourses'" ref="purchasedCourses" type="tk"></PurchasedCourses>
      </a-drawer>

      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        :rowKey="record => record.id || record.key || Math.random()"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
        :scroll="{ x: 1500, y: 'calc(100vh - 300px)' }"
        :locale="{ emptyText: '暂无数据' }"
      >
        <!-- :scroll="{x: 1500,y:'calc(100vh - 300px)'}" -->
        <span slot="index" slot-scope="text, record, index">
          {{ (current - 1) * size + index + 1 }}
        </span>
        <!-- <span slot="nickname" slot-scope="text, record">
          <span style='color:#1890ff;cursor:pointer' @click='$refs.createForm.handleWatch(record,2)'>
          {{ record.nickname }}
        </span>
        </span> -->
        <span slot="image" slot-scope="text, record">
          <img
            v-viewer
            style="width: 48px; height: 48px; margin-top: 5px; margin-right: 5px"
            v-if="record.avatar"
            :src="record.avatar"
            preview="头像"
          />
        </span>
        <span slot="sex" slot-scope="text, record">
          <dict-tag :options="dict.type['sys_user_sex']" :value="record.sex" />
        </span>
        <span slot="isNotice" slot-scope="text, record">
          <dict-tag :options="dict.type['sys_notice_status']" :value="record.isNotice" />
        </span>
        <span slot="status" slot-scope="text, record">
          <dict-tag :options="dict.type['sys_enable_disable']" :value="record.status" />
        </span>
        <span slot="type" slot-scope="text, record">
          <a v-if="record.type == 1||record.type == 2" @click="handleMemberOrder(record)">{{ customRender(record.type) }}</a>
          <p v-else>{{ customRender(record.type) }}</p>
          <p>{{ record.memberCategory_dictText }}</p>
        </span>

        <span slot="dynamicPubNum" slot-scope="text, record">
          <a @click="userDynamicsInfo(record, 1)"> <a-icon />{{ record.dynamicPubNum }} </a>
        </span>
        <span slot="checkInNum" slot-scope="text, record">
          <a @click="userDynamicsInfo(record, 2)"> <a-icon />{{ record.checkInNum }} </a>
        </span>
        <span slot="couponBalance" slot-scope="text, record">
          <a @click="userVoucher(record)"> <a-icon />{{ record.couponBalance }} </a>
        </span>
        <span slot="scoreBalance" slot-scope="text, record">
          <a @click="userScoreBalance(record)"> <a-icon />{{ record.scoreBalance }} </a>
        </span>
        <span slot="coinBalance" slot-scope="text, record">
          <a @click="userCoinBalance(record)"> <a-icon />{{ record.coinBalance }} </a>
        </span>

        <span slot="balance" slot-scope="text, record">
          <a @click="userBalance(record)"> <a-icon />{{ record.balance }} </a>
        </span>
        <span slot="rechargeNum" slot-scope="text, record">
          <a @click="userRechargeNum(record)"> <a-icon />{{ record.rechargeNum }} </a>
        </span>
        <span slot="withdrawalNum" slot-scope="text, record">
          <a @click="userWithdrawalNum(record)"> <a-icon />{{ record.withdrawalNum }} </a>
        </span>
        <span slot="goodsOrderNum" slot-scope="text, record">
          <a @click="userOrder(record, '1,2,3')"> <a-icon />{{ record.goodsOrderNum }} </a>
        </span>
        <span slot="purchasedCoursesNum" slot-scope="text, record">
          <a @click="PurchasedCourses(record)"> <a-icon />{{ record.purchasedCoursesNum }} </a>
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>

        <span slot="operation" slot-scope="text, record, index">
<!--          <a @click="handleMotion(record, 0, index)" v-hasPermi="['zb:user:edit']"> <a-icon type="edit" /> 编辑 </a>-->
          <a @click="handleCancel(record, 0, index)" v-if="record.status == 1" v-hasPermi="['zb:user:edit']">
            <a-icon type="edit" />冻结
          </a>
          <a @click="handleSetCurator(record)" v-hasPermi="['zb:user:edit']" style="margin-left: 8px;">
            <a-icon type="setting" />设置馆长
          </a>

          <a @click="handleCancel(record, 1, index)" v-if="record.status == 0" v-hasPermi="['zb:user:edit']">
            <a-icon type="edit" />解冻
          </a>
          <a @click="isTeenagersCancel(record)" v-if="record.isTeenagers == 1" v-hasPermi="['zb:user:edit']">
            <a-icon type="edit" />关闭青少年
          </a>
        </span>
      </a-table>

      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="(total) => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageUser, listUser, delUser, updateUser } from '@/api/biz/user'
import CreateForm from './modules/CreateForm'
import ManageMent from '../../dynamics/info/index'
import VouCher from '../../user/voucher/index'
import Withdrawal from '../../withdraw/index'
import scoreBalance from '../../user/scoreBalance/index'
import CoinRecord from '../../user/coinRecord/coin'
import rechargeNum from '../../user/rechargeNum/index'

// import MemberOrder from '../../member/memberOrder/index'

import Motion from '../../motion/motion/index'
import Diet from '../../diet/diet/index'
// import DrinkWater from '../../drinkWater/drinkWater/index'
// import DietaryAnalysis from '../../dietaryAnalysis/dietaryAnalysis/index'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'User',
  components: {
    CreateForm,
    ManageMent,
    VouCher,
    scoreBalance,
    CoinRecord,
    rechargeNum,
    Withdrawal,
    // 以下组件已注释，如需使用请取消注释并确保已正确导入
    // Order,
    // Health,
    // Youxuan,
    // MemberOrder,
    // PurchasedCourses,
    // Motion,
    // Diet,
    // DrinkWater,
    // DietaryAnalysis,
  },
  mixins: [tableMixin],
  dicts: ['sys_user_sex', 'sys_notice_status', 'sys_enable_disable'],
  data() {
    return {
      record:{},
      currentRecord:{},
      activeKey: 'order',
      activeKeys: 'motion',
      names: '',
      open: false,
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      current: 0,
      size: 0,
      // 查询参数
      queryParam: {
        mobile: null,
        isTeenagers: null,
        email: null,
        nickname: null,
        sex: null,
        invitationCode: null,
        isNotice: null,
        status: null,

        type: null,
        memberCategory: null,
        memberCategory_dictText: null,
        dynamicPubNum: null,
        checkInNum: null,
        challengeNum: null,
        totalCoupon: null,
        couponBalance: null,
        totalScore: null,
        scoreBalance: null,
        totalBalance: null,
        balance: null,
        rechargeNum: null,
        withdrawalNum: null,
        consumptionNum: null,
        goodsOrderNum: null,
        purchasedCoursesNum: null,

        pageNum: 1,
        pageSize: 10,
      },
      columns: [
        {
          title: '序号',
          dataIndex: 'index',
          key: 'index',
          align: 'center',
          width: 100,

          fixed: 'left',
          scopedSlots: { customRender: 'index' },
        },

        {
          title: '昵称',
          dataIndex: 'nickname',
          ellipsis: true,
          align: 'center',
          // width: 80,
          // fixed: 'left',
        },

        {
          title: '头像',
          dataIndex: 'avatar',
          ellipsis: true,
          scopedSlots: { customRender: 'image' },
          align: 'center',
          // width: 100,
        },

        {
          title: '手机号',
          dataIndex: 'mobile',
          ellipsis: true,
          align: 'center',
          // width: 100,
        },
        {
          title: '性别',
          dataIndex: 'sex',
          scopedSlots: { customRender: 'sex' },
          ellipsis: true,
          align: 'center',
          // width: '10%',
        },
        {
          title: '生日',
          dataIndex: 'birthday',
          ellipsis: true,
          align: 'center',
          // width: '50',
        },

        {
          title: '用户状态',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          ellipsis: true,
          align: 'center',
          // width: 90,
        },
        // {
        //   title: '会员类型',
        //   dataIndex: 'type',
        //   ellipsis: true,
        //   align: 'center',
        //   width: 90,

        //   scopedSlots: { customRender: 'type' },
        // },
        // {
        //   title: '会员星级',
        //   dataIndex: 'memberCategory_dictText',
        //   ellipsis: true,
        //   align: 'center',
        //   width: 90,
        // },
        // {
        //   title: '会员',
        //   dataIndex: 'memberCategory_dictText',
        //   ellipsis: true,
        //   align: 'center',
        //   width: 150,
        //   scopedSlots: { customRender: 'type' },
        // },
        {
          title: '动态数',
          dataIndex: 'dynamicPubNum',
          ellipsis: true,
          align: 'center',
          width: 90,
          scopedSlots: { customRender: 'dynamicPubNum' },
        },
        // {
        //   title: '打卡数',
        //   dataIndex: 'checkInNum',
        //   ellipsis: true,
        //   align: 'center',
        //   width: 90,
        //   scopedSlots: { customRender: 'checkInNum' },
        // },
        // {
        //   title: '挑战赛',
        //   dataIndex: 'challengeNum',
        //   ellipsis: true,
        //   align: 'center',
        //   width: 90,
        // },
        // {
        //   title: '总现金券',
        //   dataIndex: 'totalCoupon',
        //   ellipsis: true,
        //   align: 'center',
        //   width: 90,
        // },
        // {
        //   title: '现金券',
        //   dataIndex: 'couponBalance',
        //   ellipsis: true,
        //   align: 'center',
        //   width: 90,
        //   scopedSlots: { customRender: 'couponBalance' },
        // },
        // {
        //   title: '总积分',
        //   dataIndex: 'totalScore',
        //   ellipsis: true,
        //   align: 'center',
        //   width: 90,
        // },
        // {
        //   title: '积分',
        //   dataIndex: 'scoreBalance',
        //   ellipsis: true,
        //   align: 'center',
        //   width: 90,
        //   scopedSlots: { customRender: 'scoreBalance' },
        // },
        // {
        //   title: '金币',
        //   dataIndex: 'coinBalance',
        //   ellipsis: true,
        //   align: 'center',
        //   width: 90,
        //   scopedSlots: { customRender: 'coinBalance' },
        // },
        // {
        //   title: '余额',
        //   dataIndex: 'balance',
        //   align: 'center',
        //   width: 90,
        //   scopedSlots: { customRender: 'balance' },
        // },
        //
        // {
        //   title: '充值金额',
        //   dataIndex: 'rechargeNum',
        //
        //   align: 'center',
        //   width: 90,
        //   scopedSlots: { customRender: 'rechargeNum' },
        // },
        // {
        //   title: '提现金额',
        //   dataIndex: 'withdrawalNum',
        //   align: 'center',
        //   width: 90,
        //   scopedSlots: { customRender: 'withdrawalNum' },
        // },
        // {
        //   title: '消费数',
        //   dataIndex: 'consumptionNum',
        //   ellipsis: true,
        //   align: 'center',
        //   width: 90,
        // },

        // {
        //   title: '商品订单数',
        //   dataIndex: 'goodsOrderNum',
        //   ellipsis: true,
        //   align: 'center',
        //   width: 120,
        //   scopedSlots: { customRender: 'goodsOrderNum' },
        // },
        {
          title: '馆长种类',
          dataIndex: 'teenagersName',
          ellipsis: true,
          align: 'center',
          width: 80,
        },
        {
          title: '注册时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center',
          width: 150,
        },
        {
          title: '版本',
          dataIndex: 'edition',
          ellipsis: true,
          align: 'center',
          width: 100,
        },

        {
          title: '操作',
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          align: 'center',
          fixed: 'right',
          width: 100,
        },
      ],
    }
  },
  filters: {},
  created() {
    console.log('User 组件 created 生命周期触发')
    console.log('当前路由:', this.$route)
    // 初始化时获取列表
    this.getList()
  },
  mounted() {
    console.log('User 组件 mounted 生命周期触发')
    console.log('组件数据状态:', {
      listLength: this.list.length,
      loading: this.loading,
      total: this.total
    })
    // 确保组件挂载后数据正确显示
    if (this.list.length === 0 && !this.loading) {
      console.warn('组件挂载完成，但数据为空且未在加载中，可能存在问题')
    }
  },
  computed: {},
  watch: {},
  methods: {
    changeTabs(val) {
      console.log(val, 'val')
      switch (val) {
        case 'motion': {
          this.activeKeys = 'motion'
          this.$nextTick(() => {
            this.$refs.motion.goList(this.record)
          })
          break
        }
        case 'diet': {
          this.activeKeys = 'diet'
          this.$nextTick(() => {
            this.$refs.diet.goList(this.record)
          })
          break
        }
        case 'drinkWater': {
          this.activeKeys = 'drinkWater'
          this.$nextTick(() => {
            this.$refs.drinkWater.goList(this.record)
          })
          break
        }
        case 'dietaryAnalysis': {
          this.activeKeys = 'dietaryAnalysis'
          this.$nextTick(() => {
            this.$refs.dietaryAnalysis.goList(this.record)
          })
          break
        }
      }
    },
    onClose() {
      this.open = false
    },
    handleMotion(record) {
      this.record = record
      this.open = true
      this.names = 'motion'
      this.activeKeys = 'motion'
      this.$nextTick(() => {
        this.$refs.motion.goList(record)
      })
    },
    customRender(f) {
      if (f == 1) {
        return '普通会员'
      } else if (f == 2) {
        return '星级会员'
      } else {
        return ''
      }
    },
    handleMemberOrder(record) {
      this.open = true
      this.names = 'memberOrder'
      this.$nextTick(() => {
        this.$refs.memberOrder.goList(record)
      })
    },
    // 查看打卡 这边是父组件打开弹框的
    userDynamicsInfo(record, type) {
      this.open = true
      this.names = 'manageMent'
      this.$nextTick(() => {
        this.$refs.manageMent.goList(record, type)
     })
    },
    // 查看代金券
    userVoucher(record) {
      this.open = true
      this.names = 'vouCher'
      this.$nextTick(() => {
        this.$refs.vouCher.goList(record)
      })

      // this.$router.push({ path: '/app/user/user/voucher', query: { userId: record.id } })
    },
    // 积分
    userScoreBalance(record) {
      this.open = true
      this.names = 'scoreBalance'
      this.$nextTick(() => {
        this.$refs.scoreBalance.goList(record)
      })
    },

    userCoinBalance(record){
      this.open = true
      this.names = 'coinBalance'
      this.$nextTick(() => {
        this.$refs.coinBalance.goList(record)
      })
    },
    // 1:充值 2:支付 3:退款 4:提现 7 冻结
    userBalance(record) {
      this.open = true
      this.names = 'rechargeNum'
      this.$nextTick(() => {
        this.$refs.rechargeNum.goList(record, null)
      })
    },
    userRechargeNum(record) {
      this.open = true
      this.names = 'rechargeNum'
      this.$nextTick(() => {
        this.$refs.rechargeNum.goList(record, 1)
      })
    },
    userWithdrawalNum(record) {
      this.open = true
      this.names = 'withdrawal'
      this.$nextTick(() => {
        this.$refs.withdrawal.goList(record)
      })
    },
    // 查看订单信息

    changeOrder(e){
     if(e=="order"){
       this.$nextTick(() => {
         this.$refs.order.goList(this.currentRecord, '1,2,3')
       })
     }else if(e == "health"){
       this.$nextTick(() => {
         this.$refs.health.goList(this.currentRecord, '1,2,3')
       })
     }else{
       this.$nextTick(() => {
         this.$refs.youxuan.goList(this.currentRecord, '1,2,3')
       })
     }
    },
    userOrder(record, types) {
      this.open = true
      this.names = 'order'
      this.currentRecord = record
      console.log("1231231231231321")
      this.$nextTick(() => {
        this.$refs.order.goList(record, '1,2,3')
      })
      // this.$router.push({ path: '/order/manage/order', query: { userId: record.id, types: types } })
    },
    // 已购课
    PurchasedCourses(record) {
      this.open = true
      this.names = 'purchasedCourses'
      this.$nextTick(() => {
        this.$refs.purchasedCourses.goList(record)
      })
    },
    /** 查询用户信息列表 */
    getList() {
      this.loading = true
      // 清理查询参数中的null值，避免发送不必要的参数
      const params = {}
      Object.keys(this.queryParam).forEach(key => {
        if (this.queryParam[key] !== null && this.queryParam[key] !== undefined && this.queryParam[key] !== '') {
          params[key] = this.queryParam[key]
        }
      })
      // 确保分页参数存在
      params.pageNum = this.queryParam.pageNum || 1
      params.pageSize = this.queryParam.pageSize || 10

      console.log('用户列表请求参数:', params)

      pageUser(params)
        .then((response) => {
          console.log('用户列表API响应:', response)

          // 处理不同的响应数据结构
          let pageData = null
          if (response) {
            // 如果响应直接是分页数据
            if (response.records && Array.isArray(response.records)) {
              pageData = response
            }
            // 如果响应在 data 中
            else if (response.data) {
              // 如果 data 直接是分页数据
              if (response.data.records && Array.isArray(response.data.records)) {
                pageData = response.data
              }
              // 如果 data 中还有 data（双重包装）
              else if (response.data.data && response.data.data.records && Array.isArray(response.data.data.records)) {
                pageData = response.data.data
              }
            }
          }

          if (pageData) {
            this.list = pageData.records || []
            this.total = pageData.total || 0
            this.current = pageData.current || 1
            this.size = pageData.size || 10
            console.log('用户列表数据加载成功:', {
              list: this.list.length,
              total: this.total,
              current: this.current,
              size: this.size
            })
          } else {
            console.warn('响应数据格式异常:', response)
            this.list = []
            this.total = 0
            this.current = 1
            this.size = 10
            this.$message.warning('数据格式异常，请检查接口返回')
          }
          this.loading = false
        })
        .catch((error) => {
          console.error('获取用户列表失败:', error)
          console.error('错误详情:', {
            message: error.message,
            response: error.response,
            stack: error.stack
          })

          let errorMsg = '获取用户列表失败，请稍后重试'
          if (error.response) {
            if (error.response.status === 403) {
              errorMsg = '没有权限访问该接口'
            } else if (error.response.status === 404) {
              errorMsg = '接口不存在，请检查API地址'
            } else if (error.response.data && error.response.data.message) {
              errorMsg = error.response.data.message
            }
          } else if (error.message) {
            errorMsg = error.message
          }

          this.$message.error(errorMsg)
          this.loading = false
          this.list = []
          this.total = 0
        })
    },
    handleCancel(record, status, index) {
      let that = this
      if (status == 0) {
        this.$confirm({
          title: '确认冻结所选中数据?',
          content: '当前选中序号为' + ((this.current - 1) * this.size + index + 1) + '的数据',
          onOk() {
            return updateUser({ id: record.id, status: status }).then(() => {
              that.getList()
              that.$message.success('操作成功', 3)
            })
          },
          onCancel() {
            //取消清空删除ids列表
          },
        })
      } else {
        updateUser({ id: record.id, status: status }).then(() => {
          that.getList()
          that.$message.success('操作成功', 3)
        })
      }
    },

    isTeenagersCancel(record) {
      let that = this
      this.$confirm({
        title: '确认解除所选中数据?',
        content: '当前选中呢称为' + record.nickname + '的数据',
        onOk() {
          return updateUser({ id: record.id, isTeenagers: 0 }).then(() => {
            that.getList()
            that.$message.success('操作成功', 3)
          })
        },
      })
    },

    /** 设置馆长 */
    handleSetCurator(record) {
      console.log('父组件 handleSetCurator 被调用', record)
      console.log('this.$refs.createForm:', this.$refs.createForm)
      if (this.$refs.createForm) {
        console.log('调用子组件的 handleSetCurator')
        this.$refs.createForm.handleSetCurator(record)
      } else {
        console.error('createForm ref 未找到')
        this.$message.error('组件未初始化')
      }
    },

    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        mobile: undefined,
        isTeenagers: undefined,
        email: undefined,
        nickname: undefined,
        sex: undefined,
        invitationCode: undefined,
        isNotice: undefined,
        status: undefined,
        pageNum: 1,
        pageSize: 10,
      }
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk() {
          let data = []
          that.ids.map((id) => data.push({ id: id }))
          return delUser(data).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('删除成功', 3)
          })
        },
        onCancel() {
          //取消清空删除ids列表
          that.ids = []
        },
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk() {
          that.download(
            'biz/user/export',
            {
              ...that.queryParam,
            },
            `用户信息_${new Date().getTime()}.xlsx`
          )
        },
        onCancel() {},
      })
    },
  },
}
</script>
